import React from 'react'
import ProkrayaLanding from './ProkrayaLanding'
import Benifits from './Benifits'
import Products from './Products'
import WhyProkraya from './WhyProkraya'
import LogoScrollComponent from './LogoScroll'
import ContactForm from '../../../ContactForm/ContactUs'
import { useRef } from 'react'
import { Helmet } from 'react-helmet';

const Prokraya = () => {
  const contact = useRef(null)
  return (
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PTKCS Tech | Prokraya – Procurement & Spend Management Solutions</title>
        <meta 
          name="description" 
          content="PTKCS Tech offers Prokraya, a comprehensive procurement and spend management solution designed to streamline purchasing processes, enhance supplier collaboration, and provide real-time spend analytics. Our platform enables businesses to optimize procurement operations, reduce costs, and improve compliance." 
        />
        <meta 
          name="keywords" 
          content="Prokraya, procurement solutions, spend management, supplier collaboration, purchasing processes, spend analytics, procurement optimization, cost reduction, compliance management, PTKCS Tech" 
        />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PTKCS Tech" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


                  <section>
              <ProkrayaLanding contact={ contact} />
          </section>
          
          <section>
              <Benifits />
          </section>

          <section>
                <Products />
          </section>

           <section>
               <WhyProkraya />
            </section>
    
            <section>
                <LogoScrollComponent />
      </section>
      
      <section>
        <ContactForm ref={ contact} />
      </section>

    </div>
  )
}


export default Prokraya
